import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmaQuestionnaire } from '@aphp-ema/common/questionnaire';
import { EmaQuestionnaireNotificationScheduling } from './EmaQuestionnaireNotificationScheduling';

type EmaQuestionnaireListProps = {
  emaQuestionnaires: EmaQuestionnaire[] | undefined;
};

export const EmaQuestionnaireList: React.FC<EmaQuestionnaireListProps> = ({
  emaQuestionnaires,
}) => {
  const { t } = useTranslation();

  if (!emaQuestionnaires || emaQuestionnaires.length === 0) {
    return (
      <Typography variant="body1" sx={{ mb: 1 }}>
        {t('pages.studies.emaQuestionnaire.show.noEmaQuestionnaires')}
      </Typography>
    );
  }

  return emaQuestionnaires.map((emaQuestionnaire, index) => (
    <Paper elevation={2} sx={{ p: 4, mb: 3 }} key={emaQuestionnaire.id}>
      <Box>
        <Typography variant="body1" fontWeight="bold" sx={{ mb: 1 }}>
          {`EMA Questionnaire ${index + 1}`}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t('pages.studies.emaQuestionnaire.show.id', {
            id: emaQuestionnaire.id,
          })}
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {t('pages.studies.emaQuestionnaire.show.title', {
            title: emaQuestionnaire.title,
          })}
        </Typography>
      </Box>
      <EmaQuestionnaireNotificationScheduling
        emaQuestionnaire={emaQuestionnaire}
      />
    </Paper>
  ));
};
